import { type NotificationBase } from '@/store/notifications/notifications'
import type { Props as PropsNotificationAddressUpdated } from '@/components/PmNotification/PmNotificationAddressUpdated/PmNotificationAddressUpdated.vue'

export interface NotificationAddressUpdated {
  type: 'NotificationAddressUpdated'
  props: Omit<PropsNotificationAddressUpdated, keyof NotificationBase>
}

export function normalizeNotificationAddressUpdated() {
  const result: NotificationAddressUpdated = {
    type: 'NotificationAddressUpdated',
    props: {},
  }

  return result
}
